import { Component, OnInit, ElementRef, Renderer2 } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api/lazyloadevent';
import { PayOnEmailService } from '../service/pay-on-email.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PoeDataService } from '../service/poe-data.service';
import { Utility } from '../app.utility';
import { DatePipe } from '@angular/common';
import { ConvenienceFeeRequest } from '../models/request/ConvenienceFeeRequest';
import { Payments } from '../models/request/Payments';
import { MemcacheResponse } from '../models/request/MemcacheResponse';
import { Invoices } from '../models/request/Invoices';
import { ConvenienceFeeDocuments } from '../models/request/ConvenienceFeeDocuments';
import { PaymentDetails } from '../models/request/PaymentDetails';
import { PaymentDocuments } from '../models/request/PaymentDocuments';
import { MetadataResponse } from '../models/request/MetadataResponse';
import { Metadata } from '../models/request/Metadata';
import { CacheDataStorage } from '../models/request/CacheDataStorage';
import { MessageService } from '@arc/aureus';
import { PACResponse } from '../models/request/PACResponse';
import { IG6Response } from '../models/request/IG6Response';
import { HostListener } from "@angular/core";
import { AppMonitoringService } from '../service/app-monitoring.service';
import { DateModule } from '../util/DateModule';
@Component({
  selector: 'app-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.scss']

})
export class ReviewComponent implements OnInit {
  // @Output() nextPrevEvent = new EventEmitter<string>();
  // @ViewChildren(CalendarModule) public cals: CalendarModule[];
  agreement: boolean;
  public invoiceValues: any[];
  public cols: any[];
  public isExpanded: boolean = false;
  public loading: boolean = false;
  public shortPayHeader: boolean = false;
  public rows: number = 10;
  public expandedRows = {};
  public virtualCars: any[];
  public temDataLength: number = 0;
  showShortPayBody = {};
  selectedRowData: any[];
  TotalDocumentAmount = 0;
  errorValidation = false;
  payment_date = '';
  ValidationMessage: string;
  private regex: RegExp = new RegExp("^\\d+(?:\\.\\d{0,2})?$");
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', '-', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];
  public customerInfo: any = {};
  isMobileCheckDevice: boolean = false;
  uniqueToken: string;
  clientGuiId: string;
  customerId: number;
  primaryCustomerId: number;
  paymentAccountId: number;
  paymentDate: string;
  accountNumber: number;
  invoiceIds: number[];
  reviewFormdata: any;
  convenienceFeeAmount: any;
  convenienceFeeError: any = null;
  pacResponse: PACResponse;
  paymentType: string;
  colLength: number = 7;
  scrHeight: any;
  scrWidth: any;
  accessToken: string;
  poeUsesDiscounts: string;
  poeAllowIGCCDiscounts: string;
  usesOpenBalance: string;
  poeAllowStatementPayments: string;
  subTotalAmountwithDiscount = 0;
  totalAmountwithDiscount = 0;
  isConvenienceLableShow = true;
  appKey: string;
  _customConvenienceFeeACH: string;
  _customConvenienceCC: string;
  _customConvenienceFeeLabel: string = "Convenience Fee:";
  isCustomConvenienceLableShow: boolean = false;
  currencyType: string;
  currencyVal: string;
  customerType: string;
  userId: number;
  achLabel = "ACH";
  ccLabel = "CC";
  convFeeDocumentObj: ConvenienceFeeDocuments[] = [];

  constructor(private el: ElementRef,
    private renderer:Renderer2,
    private PayOnEmailService: PayOnEmailService,
    private router: Router,
    private route: ActivatedRoute,
    private PoeDataService: PoeDataService,
    public util: Utility,
    private datePipe: DatePipe,
    public messageService: MessageService,
    private appMonitoringService: AppMonitoringService,
    private dateModule: DateModule
  ) {
    this.uniqueToken = encodeURIComponent(this.route.snapshot.paramMap.get('uniquetoken'));
    this.GetAccessToken();
  }
  GetAccessToken() {
    this.PoeDataService.GetAccessToken().subscribe(data => {
      this.accessToken = data;
    });
  }

  ngOnInit() {
    this.selectedRowData = [];
    this.reviewFormdata = {
      accountName: '', accountNumber: '', totalDocument: '',
      paymentDate: '', name: '', paymentType: '',
      accountType: '', subTotal: 0.00, convenienceFee: this.convenienceFeeAmount,
      totalAmount: 0.00
    };

    this.cols = [
      { field: 'documentId', header: 'Document', label: 'Invoice', class: 'display-block' },
      { field: 'dueDate', header: 'Dates', label: 'Due Date', class: 'display-block' },
      { field: 'openBalance', header: 'Amounts', label: 'Open Balance', class: 'display-block' },
      { field: 'paidOnline', header: 'Paid Online', label: '', class: 'display-block' },
      { field: 'payAmount', header: 'Pay Amount', label: '', class: 'display-block' },
      { field: 'short_pay', header: 'Short Pay Reason', label: '', class: 'display-none' },
    ];
    let keys: Array<string> = ["PACCacheResponse", "documentmetadata"];
    this.PayOnEmailService.GetMemcaches(keys, this.accessToken).subscribe(data2 => {
      if (data2.status === 200) {
        debugger;
        let result: any = JSON.parse(data2.body.memcachedValues);
        if (result.PACCacheResponse) {
          this.pacResponse = JSON.parse(result.PACCacheResponse.replace(/\\/g, "")) as PACResponse;
          if (this.pacResponse.paymentType == "CC") {
            this.paymentType = "C";
          } else if (this.pacResponse.paymentType == "ACH") {
            this.paymentType = "B";
          }
        }
        if (result.documentmetadata) {
          let cacheDataStorage: CacheDataStorage = JSON.parse(result.documentmetadata) as CacheDataStorage;
          this.poeUsesDiscounts = cacheDataStorage.PoeUsesDiscounts;
          this.poeAllowIGCCDiscounts = cacheDataStorage.PoeAllowIGCCDiscounts;
          this.reviewFormdata.accountName = cacheDataStorage.AccountName;
          this.reviewFormdata.accountNumber = cacheDataStorage.AccountNumber;
          this.poeAllowStatementPayments = cacheDataStorage.POEAllowStatementPayments;
          this.usesOpenBalance = cacheDataStorage.UsesOpenBalance;
          this.reviewFormdata.paymentDate = this.checkDateFormate(this.pacResponse.paymentDate);
         
          if (cacheDataStorage.EnableFlexbilePay) {
            let invoics: Invoices[] = JSON.parse(cacheDataStorage.flexDocuments.replace(/\\"/g, '"').replace(/\\\\/g, '\\')) as Invoices[];
            this.reviewFormdata.totalDocument = invoics.length;
            this.invoiceValues = invoics;
          } else {
            let invoics: Invoices[] = JSON.parse(cacheDataStorage.Documents.replace(/\\"/g, '"').replace(/\\\\/g, '\\')) as Invoices[];
            this.reviewFormdata.totalDocument = cacheDataStorage.TotalDocuments;
            this.invoiceValues = invoics;
          }

          this.reviewFormdata.currency = cacheDataStorage.Currency;
          this.currencyVal = cacheDataStorage.Currency;
          if (cacheDataStorage.Currency == "CAD") {
            this.currencyType = "(CAD) ";
          }
          this.convFeeDocumentObj = [];
          this.invoiceValues.forEach((row, index) => {
            let payAmount = 0;
            if (this.invoiceValues[index].showPay) {
              if (this.invoiceValues[index].shortPayText != '') {
                this.invoiceValues[index].ShortPayTextDetails = this.invoiceValues[index].shortPayText.slice(0, 20) +
                  (this.invoiceValues[index].shortPayText.length > 20 ? "..." : "");
              } else {
                this.invoiceValues[index].ShortPayTextDetails = '';
              }
              this.shortPayHeader = true;
            } else {
              //Discount logic Start 
              if (new Date(this.checkDateFormate(this.pacResponse.paymentDate)) <= new Date(this.checkDateFormate(row.discountDate)) &&
                this.invoiceValues[index].payAmount === row.actualAmount) {
                if (this.poeUsesDiscounts == "Y" && this.paymentType == "B") {
                  if(this.usesOpenBalance == "Y"){
                    if(this.poeAllowStatementPayments == "Y" && row.itemType == "S"){
                      payAmount = (((row.totalDue) - (row.paidOnline)) - (row.discountAmount)); 
                    }
                    else{
                      payAmount = (((row.openBalance) - (row.paidOnline)) - (row.discountAmount));
                    }
                  }
                  if(this.usesOpenBalance != "Y"){
                    payAmount = (((row.totalDue) - (row.paidOnline)) - (row.discountAmount)); 
                  }
                  this.invoiceValues[index].payAmount = payAmount;
                } else if (this.poeAllowIGCCDiscounts == "Y" && this.paymentType == "C") {
                  if(this.usesOpenBalance == "Y"){
                    if(this.poeAllowStatementPayments == "Y" && row.itemType == "S"){
                      payAmount = (((row.totalDue) - (row.paidOnline)) - (row.discountAmount)); 
                    }
                    else{
                      payAmount = (((row.openBalance) - (row.paidOnline)) - (row.discountAmount));
                    }
                  }
                  if(this.usesOpenBalance != "Y"){
                    payAmount = (((row.totalDue) - (row.paidOnline)) - (row.discountAmount)); 
                  }
                  this.invoiceValues[index].payAmount = payAmount;
                }
              }
              //Discount logic End
            }
            //Total and sub total calculation start 
            this.subTotalAmountwithDiscount += (row.payAmount);
            this.reviewFormdata.subTotal = this.subTotalAmountwithDiscount;
            this.reviewFormdata.totalAmount = this.subTotalAmountwithDiscount + (this.reviewFormdata.convenienceFee || 0.00);
            //Total and sub total calculation End
            this.convFeeDocumentObj.push({DocumentId:row.documentId,PaymentAmount:row.payAmount});

          });
        }
        this.CalculateConveniencFee();
        this.getScreenSize();
      }
      else this.router.navigate(['/errors']);
    },
      error => {
        console.log(`Clearmemcache: ${error}`);
        this.router.navigate(['/errors']);
      });
    this.customerInfo = {
      customerName: '',
      customerAccountNumber: '',
    }
  }

  ngAfterViewInit() {
    let element = this.el.nativeElement.querySelector('.p-datatable-wrapper');
    this.renderer.removeStyle(element, 'height');
    this.renderer.setStyle(element, 'max-height', '300px');
  }

  CalculateConveniencFee() {
    this.PoeDataService.getPoeMetaData().subscribe(data => {
      if (!this.util.isEmpty(data)) {
        let resultData = data as MetadataResponse;
        this.customerId = resultData.customerId;
        this.primaryCustomerId = resultData.primaryCustomerId;
        this.accountNumber = resultData.accountNumber;
        this.clientGuiId = resultData.clientGuid;
        this.appKey = resultData.appKey;
        this.customerType = resultData.customerType;
        var parseVal = JSON.parse(resultData.metaData) as Metadata;
        let convenienceFeeRequest = new ConvenienceFeeRequest();
        let paymentsObj = new Payments();
       
        paymentsObj.Application = "POE";
        paymentsObj.CustomerId = resultData.customerId;  
        paymentsObj.AccountNumber = resultData.accountNumber;
        paymentsObj.PaymentAmount = null;
        paymentsObj.PaymentDate = this.reviewFormdata.paymentDate;
        paymentsObj.Documents = this.convFeeDocumentObj;

        convenienceFeeRequest.PrimaryCustomerId = resultData.primaryCustomerId.toString();

        this.PayOnEmailService.GetMemcache("PACCacheResponse", this.accessToken).subscribe(data2 => {
          if (data2.status === 200) {
            let memcacheResponse: MemcacheResponse = data2.body as MemcacheResponse;
            if (!memcacheResponse.memcachedValue.isNull) {
              this.pacResponse = JSON.parse(memcacheResponse.memcachedValue.value.replace(/\\/g, "")) as PACResponse;
              this.reviewFormdata.name = this.pacResponse.nameOnAccount;
              this.reviewFormdata.shortName = this.reviewFormdata.name.slice(0, 30) + (this.reviewFormdata.name.length > 30 ? "..." : "");
              this.reviewFormdata.paymentType = this.pacResponse.paymentType;
              this.reviewFormdata.accountType = this.pacResponse.accountType;
              this.userId = this.pacResponse.userId;
              if (parseVal.POE.CustomConvenienceFeeLabel != null && parseVal.POE.CustomConvenienceFeeLabel != '') {
                this._customConvenienceFeeLabel = `${parseVal.POE.CustomConvenienceFeeLabel}:`;
                if (this.reviewFormdata.paymentType == "CC" && parseVal.POE.CustomConvenienceCC) {
                    this._customConvenienceCC = parseVal.POE.CustomConvenienceCC;  
                    this.isCustomConvenienceLableShow = true;
                }
                if (this.reviewFormdata.paymentType == "ACH" && parseVal.POE.CustomConvenienceFeeACH) {
                    this._customConvenienceCC = parseVal.POE.CustomConvenienceFeeACH;  
                    this.isCustomConvenienceLableShow = true;
                }
              } 

              paymentsObj.OnlinePaymentId = this.pacResponse.paymentAccountId;
              this.paymentAccountId = this.pacResponse.paymentAccountId;

              if (parseVal.POE.UsePOETemplateConvenienceFees === 'Y' && parseVal.POE.FlexibleConvenienceFee === 'Y') {
              
                if (this.pacResponse.paymentType == this.ccLabel) {
                  this.paymentType = "C";
                } else if (this.pacResponse.paymentType == this.achLabel) {
                  this.paymentType = "B";
                } else {
                  this.convenienceFeeAmount = 0;
                  return false;
                }
              } else {
              
                if (this.pacResponse.paymentType == "CC" && parseVal.POE.POEAllowCreditCards != undefined
                  && parseVal.POE.POEAllowCreditCards == "true") {
                  this.paymentType = "C";
                } else if (this.pacResponse.paymentType == "ACH" && parseVal.POE.POEAllowCheckingAccounts != undefined
                  && parseVal.POE.POEAllowCheckingAccounts == "true") {
                  this.paymentType = "B";
                } else {
                  this.convenienceFeeAmount = 0;
                  return false;
                }
              }

              paymentsObj.PaymentMethod = this.paymentType;
              convenienceFeeRequest.Payments.push(paymentsObj);
              return this.PayOnEmailService.CalculateConveniencFee(this.accessToken, convenienceFeeRequest)
                .subscribe(responseData => {
                  if (responseData.status === 200) {
                    let convenienceFeeData = (responseData as any)['body'];
                    if (convenienceFeeData.convenienceFeesNotProcessed && convenienceFeeData.convenienceFeesNotProcessed.length > 0) {
                      this.convenienceFeeError = convenienceFeeData.convenienceFeesNotProcessed[0];
                      this.appMonitoringService.logError(new Error("Failed to Calculate Convenience Fee: " + this.convenienceFeeError.reason), {
                        responseData: responseData
                      });
                      this.isConvenienceLableShow = false;
                      return false;
                    } else if (convenienceFeeData.convenienceFees[0] != null) {
                      this.convenienceFeeError = null;
                      this.convenienceFeeAmount = convenienceFeeData.convenienceFees[0].feeAmount;
                      if (this.convenienceFeeAmount == 0 || this.convenienceFeeAmount == 0.00) {
                        this.isConvenienceLableShow = false;
                      }
                      else {
                        this.isConvenienceLableShow = true;
                      }
                      this.reviewFormdata.totalAmount = this.reviewFormdata.subTotal + (this.convenienceFeeAmount || 0.00);
                      return true;
                    } 
                    else {
                      return false;
                    }
                  }
                  else {
                    this.appMonitoringService.logError("Failed to Calculate Convenience Fee: " + responseData.status, {
                      responseData: responseData
                    });
                    return false;
                  }
                });
            }
            else {
              this.router.navigate(['/errors']);
            }
          }
        },
          error => {
            console.log(`Setmemcache: ${error}`);
            this.router.navigate(['/errors']);
          });
      }
    });
    return true;
  }

  ProcessPayment() {
    let paymentDetails = new PaymentDetails();
    this.invoiceValues.forEach((row, index) => {
      let paymentDocumentsObj = new PaymentDocuments();
      paymentDocumentsObj.documentId = this.invoiceValues[index].documentId;
      paymentDocumentsObj.amount = this.invoiceValues[index].payAmount;
      if (this.invoiceValues[index].shortPayText == "") {
        paymentDocumentsObj.reason = this.invoiceValues[index].shortPayreason;
      } else {
        paymentDocumentsObj.reason = this.invoiceValues[index].shortPayText;
      }
      paymentDetails.documents.push(paymentDocumentsObj);
    });

    paymentDetails.customerId = this.customerId.toString();
    if (this.customerType === "uc") // usercentric
      paymentDetails.userId = this.userId;

    paymentDetails.primaryCustomerId = this.primaryCustomerId;
    paymentDetails.paymentAccountId = this.paymentAccountId.toString();
    paymentDetails.paymentDate = this.datePipe.transform(this.reviewFormdata.paymentDate, 'yyyy-MM-dd');
    paymentDetails.accountNumber = this.accountNumber.toString();
    paymentDetails.paymentNote = "";
    paymentDetails.createUser = "POE";
    paymentDetails.originSystem = "POE-" + this.appKey;
    paymentDetails.optpayone = 0.00;
    paymentDetails.optpaytwo = 0.00;
    paymentDetails.MerchantDescriptor = "";
    paymentDetails.MerchantDescriptorContact = "";
    paymentDetails.usesTemplateConvenienceFees = "N";
    paymentDetails.zeroDollarPayment = "N";
    paymentDetails.docPaySplitCreateUser = "POE";
    paymentDetails.IsFullAmountPaidByCreditMemo = "";
    paymentDetails.createDocPaySplits = true;
    paymentDetails.skipConvenienceFeeCalculation = "Y";
    paymentDetails.clientGuid = this.clientGuiId;
    paymentDetails.convenienceFee = this.convenienceFeeAmount;

    this.PayOnEmailService.ProcessPayment(this.accessToken, paymentDetails)
      .subscribe(payResponseData => {
        let iG6Response: IG6Response = payResponseData.body as IG6Response;
        console.log(payResponseData);
        if (payResponseData.status === 200) {
          if (iG6Response.status == "Success") {
            this.RedirecttoConfirmationPage("success", paymentDetails, iG6Response.data.confirmationNumber);
            return true;
          } else {
            this.RedirecttoConfirmationPage("failure", paymentDetails, iG6Response.data.confirmationNumber);
          }
        }
        else {
          this.RedirecttoConfirmationPage("failure", paymentDetails, iG6Response.data.confirmationNumber);
          return false;
        }
      },
        error => {
          console.log(`Setmemcache: ${error}`);
          this.RedirecttoConfirmationPage("failure", paymentDetails, "");

        });
  }
  RedirecttoConfirmationPage(status: string, paymentDetails: PaymentDetails, confirmationDate: string) {
    let Cache = {
      "ReviewDocuments": JSON.stringify(this.invoiceValues).replace(/"/g, '\\"'),
      "TotalBalance": this.reviewFormdata.totalAmount,
      "Subtotal": this.reviewFormdata.subTotal,
      "ConfirmationNumber": confirmationDate,
      "ConvenienceFee": this.convenienceFeeAmount,
      "Documents": paymentDetails.documents,
      "PaymentDate": paymentDetails.paymentDate,
      "Currency": this.reviewFormdata.currency
    };
    let cacheString: string = JSON.stringify(Cache);
    this.PayOnEmailService.SetMemcache("reviewmetadata", cacheString, this.accessToken).subscribe(data2 => {
      if (data2.status === 200) {
        this.router.navigate(["confirm", status, decodeURIComponent(this.uniqueToken)]);
      }
    },
      error => {
        console.log(`Setmemcache: ${error}`);
      });
  }
  checkDateFormate(date) {
    return this.util.dateFormate(date);
  }
  currencyToNumber(value: string): number {
    const regex: RegExp = /[\$\,]/g;
    return +value.replace(regex, '');
  }
  numberToCurrency(value: number): string {
    let formattedValue = `${value}`;
    const valueArray = [];
    if (formattedValue.length > 2) {
      while (formattedValue.length > 0) {
        valueArray.unshift(formattedValue.slice(-3));
        formattedValue = formattedValue.slice(0, -3);
      }
      return `$${valueArray.join(',')}.00`;
    }
    return `${formattedValue}`;
  }

  formatNumber(num) {
    return this.util.formatNumber(num);
  }
  private _selectedRows: any;
  public get selectedRows(): any {
    return this._selectedRows;
  }
  public set selectedRows(value: any) {
    if (value !== this._selectedRows) {
      this._selectedRows = value;
      this.selectedAmount = 0;
      value.forEach(row => {
        this.selectedAmount += (row.totalDue);
      });
    }
  }
  onClick() {
    if (this.selectedRows) {
      if (this.selectedRows.length === this.invoiceValues.length) {
        this.selectedRows = [];
      } else {
        this.selectedRows = this.invoiceValues;
      }
    } else {
      this.selectedRows = this.invoiceValues;
    }
  }
  selectedAmount = 0;
  expandAll() {
    if (!this.isExpanded) {
      this.invoiceValues.forEach(data => {
        this.expandedRows[data.documentId] = 1;
      })
    } else {
      this.expandedRows = {};
    }
    this.isExpanded = !this.isExpanded;
  }
  onRowExpand() {
    if (Object.keys(this.expandedRows).length === this.temDataLength) {
      this.isExpanded = true;
    }
  }
  currency: string = 'USD';
  localStringToNumber(s) {
    return Number(String(s).replace(/[^0-9.-]+/g, ""));
  }
  newValue = '';
  showShortPayBodssy = '';
  onRowCollapse() {
    if (Object.keys(this.expandedRows).length === 0) {
      this.isExpanded = false;
    }
  }
  onPage(event: any) {
    this.temDataLength = this.invoiceValues.slice(event.first, event.first + 10).length;
    this.isExpanded = false;
    this.expandedRows = {};
  }
  loadDataOnScroll(event: LazyLoadEvent) {
    this.loading = true;
    setTimeout(() => {
      if (event.first === 249980) {
        this.virtualCars = this.loadChunk(event.first, 20);
      } else {
        this.virtualCars = this.loadChunk(event.first, event.rows);
      }
      this.loading = false;
    }, 250);
  }
  loadChunk(first: number, arg1: number): any {
    throw new Error("Method not implemented.");
  }
  makepayment() {
    if (this.convenienceFeeError) {
      const errorMessage = "There was an error calculating the convenience fee.";
      this.openMessageNavigate(errorMessage + " Please review your payment method and try again.");
      this.appMonitoringService.logError(new Error(errorMessage + " The user was sent back to review their payment."));
      this.PreviousPage();
      return;
    }

    const paymentDateString = this.reviewFormdata.paymentDate;
    const now = new Date(this.dateModule.getDate().toDateString());
    if (!paymentDateString || new Date(paymentDateString) < now) {
      const errorMessage = "There was an error validating the payment date.";
      this.openMessageNavigate(errorMessage + " Please review your payment method and try again.");
      this.appMonitoringService.logError(new Error(errorMessage + " The user was sent back to review their payment."));
      this.PreviousPage();
      return;
    }
    
    if (!this.agreement) {
      this.openMessageNavigate("Please select the agreement!");
      return;
    }

    this.ProcessPayment();
  }

  PreviousPage() {
    this.router.navigate(['pac', decodeURIComponent(this.uniqueToken)]);
  }

  paymentDateValidation() {
    debugger;
    let paymentDate = "12/08/2020";// this.reviewFormdata.paymentDate;
    this.PayOnEmailService.PaymentDateValidation(paymentDate, this.accessToken).subscribe(data3 => {
      if (data3.status === 200) {
        let isPaymentDateValid: boolean = data3.body as boolean;
        if (isPaymentDateValid) {
          return true;
        } else {
          this.openMessageNavigate("You cannot schedule a payment for today. Please select a later date");
          this.router.navigate(['pac', decodeURIComponent(this.uniqueToken)]);
          return false;
        }
      }
    },
      error => {
        console.log(`paymentDateValidation: ${error}`);
        this.router.navigate(['/errors']);
      });
  }

  openMessageNavigate(message: string) {
    this.messageService.open(message,
      null,
      {
        channel: 'auth',
        dismissOthers: true,
        severity: 'warning',
        duration: 10000,
      },
    );
  }
  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.scrHeight = window.innerHeight;
    this.scrWidth = window.innerWidth;
    let colLengnIncrease = false;
    if (this.invoiceValues != undefined) {
      this.invoiceValues.forEach((row, index) => {
        if (this.invoiceValues[index].showPay) {
          colLengnIncrease = true;
        }
      });
    }
    if (this.scrWidth > 648 && 901 > this.scrWidth) {
      this.colLength = 6;
      if (colLengnIncrease) {
        this.colLength = 7;
      }
    } else {
      if (colLengnIncrease) {
        this.colLength = 8;
      } else {
        this.colLength = 7;
      }
    }
  }
}
